// extracted by mini-css-extract-plugin
export default {"wrapper":"rAOqnUwYNS4HuEKoTtex","topContentsWrapper":"QhSFesgS6dkug8xMicNI","alert":"f0sb3TfsJiiAOG_etgQZ"};